module.exports = __webpack_public_path__ + "static/media/slide3.012e9635.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slide3.jpg
// module id = 568
// module chunks = 0